<template>
  <!-- 报废审批 -->
  <a-modal
    :title="audit ? '报废审批' : '报废详情'"
    style="top: 20px"
    width="80%"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
    class="gufiiguy"
  >
    <template slot="footer">
      <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
      <a-button key="back" @click="visible = false"> 取消 </a-button>
      <a-button type="danger" style="margin-left: 8px" @click="act_task_audit_post(3)" v-show="audit">驳回</a-button>
      <a-button key="submit" type="primary" @click="act_task_audit_post(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="act_task_audit_post(2)" v-show="audit"
        >通过</a-button
      >
    </template>
    <div ref="sadsada">
      <a-form :form="form">
        <div class="title">
          <span>审批信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="审批编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.applyCode }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="抄 送 人 " :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.ccName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="报废残值价格" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <span >{{ mdl.scrappedPrice }}</span>
              </a-form-item>
            </a-col>
             <a-col :span="12">
              <a-form-item label="报废处理方式" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <span >{{ mdl.dealMethod }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="实际处理价格" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <span >{{ mdl.realPrice }}</span>
              </a-form-item>
            </a-col>
             <a-col :span="12">
              <a-form-item label="收款方式" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <span >{{ mdl.rcvMethod }}</span>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- <a-row>
				<a-col :span="8">
					<a-form-item label="标　　题" class="model_span_form" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
						<span class="spanClass">{{ mdl.title }}</span>
					</a-form-item>
				</a-col>
			
			</a-row>
			<a-row>
					<a-col :span="24">
					<a-form-item label="申请编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						<span class="spanClass">{{ mdl.applyCode }}</span>
					</a-form-item>
				</a-col>
			</a-row> -->
          <a-row>
            <a-col :span="24">
              <a-form-item label="报废原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.remark }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span class="spanClass">物品信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="8" v-if="!audit">
              <a-form-item label="物品编号" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.assetSn }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="物品名称" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.name }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="audit">
              <a-form-item label="物品编号" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.assetSn }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="型号规格" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.model }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="!audit">
            <a-col :span="8">
              <a-form-item label="责任部门" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.deptId ? deptMap[mdl.asset.deptId] : '' }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="责 任 人 " :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.charger }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="保 管 人 " :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.keeper }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="!audit">
            <a-col :span="8">
              <a-form-item label="采购时间" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.purchaseTime }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="采购价格" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.purchasePrice }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="audit">
            <a-col :span="8">
              <a-form-item label="采购时间" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.purchaseTime }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="采购价格" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.purchasePrice }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="保 管 人 " :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.keeper }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="audit">
            <a-col :span="8">
              <a-form-item label="责任部门" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.deptId ? deptMap[mdl.asset.deptId] : '' }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="责 任 人 " :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                <span class="spanClass">{{ mdl.asset.charger }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber == 1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber == 1">
          <auditModel ref="auditModel"></auditModel>
        </div>
        <!-- <a-row>
				<a-col :span="12">
					<a-form-item label="审批意见" :labelCol="labelCol" :wrapperCol="wrapperCol">
						<a-textarea v-model="comment" v-if="audit" placeholder="请输入审批意见" :auto-size="{ minRows: 2, maxRows: 6 }" />
						<span v-else>{{ comment }}</span>
					</a-form-item>
				</a-col>
			</a-row> -->
      </a-form>
    </div>
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </a-modal>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { getDictMap } from '@/utils/dict'
import { getDeptListEnable2 } from '@/api/system'
import { getScrapByBusiness, act_task_audit, scrapped_apply_downlodPdf } from '@/api/activiti'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
import { forEach } from 'store/storages/all'
const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
const deptMap = {}
export default {
  name: 'scrapModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    transferModal,
    auditModel,
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      visible: false,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      labelCol3: {
        span: 9,
      },
      wrapperCol3: {
        span: 15,
      },
      deptMap,
      businessKey: '',
      confirmLoading: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      leaveTypeMap: {},
      deptTree: [],
      form: this.$form.createForm(this),
      record: '',
    }
  },
  beforeCreate() {
    // getDictMap('act_leave_type').then((res) => {
    //   this.leaveTypeMap = res
    // })
  },
  created() {
    getDeptListEnable2().then((res) => {
      const data = res.rows
      data.forEach((item) => {
        deptMap[item.deptId] = item.deptName
      })
      console.log(data)
    
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        // this.deptTree.map((d) => {
        //   if (d.hasOwnProperty('children')) {
        //     d.children.map((b) => {
        //       deptMap[b.key] = {
        //         text: b.title,
        //       }
        //       deptMap[d.key] = {
        //         text: d.title,
        //       }
        //     })
        //   } else {
        //     deptMap[d.key] = {
        //       text: d.title,
        //     }
        //   }
        // })
        console.log(deptMap, 'deptMap=======================')
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
    console.log(deptMap, 'deptMap=========================')
  },
  methods: {
      	//导出
		downloadData() {
			downLoadPdf('/act/scrapped_apply/downlodPdf?businessKey=' + this.record.businessKey,)
    },
    handleSure() {
      this.visible = false
      this.$emit('ok')
    },
    download() {
      scrapped_apply_downlodPdf({
        businessKey: this.businessKey,
      }).then((res) => {
        window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    show(record) {
      this.recordNumber = record.recordNumber
      this.record = record
      this.businessKey = record.businessKey
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      if (record.comment != undefined) {
        this.comment = record.comment
      }

      getScrapByBusiness(record.businessKey).then((res) => {
        console.log(res)
        if (res.code == 200) {
          const { type } = res.data
          // res.data.asset.deptId = Number(res.data.asset.deptId)
          this.mdl = Object.assign(res.data)
          console.log(this.mdl, ' this.mdl===========================')
          //   this.mdl.leaveType = this.leaveTypeMap.get(type.toString())
          this.visible = true
          this.$nextTick(() => {
            Watermark.set('安联云管家', this.$refs.sadsada)
            if (!this.audit && this.recordNumber == 1) {
              this.$refs.auditModel.show(record)
            }
          })
        }
      })
    },
    //通过 驳回
    act_task_audit_post(result) {
      if (result == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.actTask()
        }
      } else if (this.result == 2) {
        this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.formData.taskId,
        procDefKey: this.formData.procDefKey,
        procInstId: this.formData.procInstId,
        procName: this.formData.procName,
        applyer: this.formData.applyer,
        result: this.result,
        businessKey: this.formData.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('审批成功')
          this.$emit('ok')
          this.visible = false
          this.is_revocation = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}
</style>
